if (!customElements.get('sc-header-account-menu')) {
  class ScHeaderAccountMenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-sc-account-menu-toggle]');
      this.panel = this.querySelector('[data-sc-account-menu-panel]');

      if (!this.toggle || !this.panel) return;

      this.onToggleClick = this.onToggleClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.toggle.addEventListener('click', this.onToggleClick);
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      if (!this.toggle || !this.panel) return;

      this.toggle.removeEventListener('click', this.onToggleClick);
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keydown', this.onKeyDown);
    }

    onToggleClick() {
      if (this.hasAttribute('open')) {
        this.close();
      } else {
        document.querySelectorAll('sc-header-account-menu[open]').forEach((menu) => {
          if (menu !== this && typeof menu.close === 'function') menu.close();
        });
        this.open();
      }
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    onKeyDown(event) {
      if (event.key !== 'Escape' || !this.hasAttribute('open')) return;

      event.preventDefault();
      this.close();
      this.toggle.focus();
    }

    open() {
      this.setAttribute('open', '');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
    }

    close() {
      this.removeAttribute('open');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
    }
  }

  customElements.define('sc-header-account-menu', ScHeaderAccountMenu);
}
